<!--    
    <v-card-text></v-card-text>
      <v-btn @click="saveFilterTodb(formData)" text> Enregistrer pour reprendre</v-btn><v-card-actions>
    </v-card-actions> 
  -->
<template>
  <v-form class="" style="max-width: 890px; margin-left: auto; margin-right: auto">
    <h2 class="text-center">Bon de commande cérémonie</h2>

    <v-progress-linear
      v-if="loading && formData.e6 == ''"
      color="primary"
      indeterminate
      rounded
      height="6"
    ></v-progress-linear>
    <v-stepper v-model="formData.e6" class="mt-2">
      <v-stepper-header style="height: 100%; width: 100%" v-if="formData.e6 !== 9">
        <v-row>
          <v-stepper-step editable :complete="formData.e6 > 0" step=""> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 1" :step="1"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 2" :step="2"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 3" :step="3"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 4" :step="4"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 5" :step="5"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 6" :step="6"> </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="formData.e6 > 7" :step="7"> </v-stepper-step>
        </v-row>
      </v-stepper-header>
      <p class="mb-3 mt-6 text-center text-h6">{{ title }}</p>
      <v-stepper-items>
        <v-stepper-content step="">
          <v-container class="pt-0">
            <v-card flat class="text-center">
              <v-card-title class="mb-5 text-center d-flex justify-center">
                <v-row>
                  <v-col class="pa-0" cols="12">
                    <v-chip-group
                      column
                      mandatory
                      active-class="primary--text"
                      @change="formData.type = $event"
                      class="mb-3"
                    >
                      <v-chip @click="formData.e6 = 1"> Particulier </v-chip>
                      <v-chip @click="formData.e6 = 1"> Professionnel </v-chip>
                    </v-chip-group>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>
                <!-- choix particulier pro  -->
              </v-card-text>
            </v-card>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="1">
          <v-container>
            <v-card flat>
              <v-card-text>
                <!-- choix particulier pro  -->

                <!-- particulier -->
                <div v-if="formData.type == 0">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        :messages="
                          VarLab.map((e) => e.label)[
                            VarLab.map((e) => e.nomVariable).indexOf('Nom')
                          ]
                        "
                        v-model="formData.Nom"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Prénom"
                        v-model="formData.Prénom"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Votre adresse postale"
                        v-model="formData.adressePostaleParticulier"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        telNom
                        rows="1"
                        hide-details="auto"
                        outlined
                        :messages="
                          VarLab.map((e) => e.label)[
                            VarLab.map((e) => e.nomVariable).indexOf('tel')
                          ]
                        "
                        v-model="formData['tel']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        v-model="formData['mail']"
                        messages="E-mail"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </div>
                <!-- pro -->
                <div v-else>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Nom de la structure"
                        v-model="formData['nomDeLaStructure']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Siret"
                        v-model="formData['Siret']"
                        required
                      ></v-textarea>
                    </v-col>
                    <!-- <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Code APE"
                        v-model="formData['CodeAPE']"
                        required
                      ></v-textarea>
                    </v-col> -->
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Représentée par (en sa qualité de):"
                        v-model="formData['représentant']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Adresse postale de correspondance:"
                        v-model="formData['Adresse']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Numéro de téléphone fixe"
                        v-model="formData['telFixe']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        messages="Numéro de téléphone mobile "
                        v-model="formData['telMob']"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-textarea
                        auto-grow
                        rows="1"
                        hide-details="auto"
                        outlined
                        v-model="formData['mail']"
                        messages="E-mail"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-container>
            <v-card class="mb-20" flat>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      :items="$store.state.groupes"
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      messages="Nom du groupe de Gospel que vous souhaitez retenir:"
                      v-model="formData['groupe']"
                      required
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-select
                      :items="formules"
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      messages="Combien de chanteurs et musiciens souhaités"
                      v-model="formData['nbChanteurs']"
                      required
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      auto-grow
                      rows="1"
                      hide-details="auto"
                      outlined
                      type="number"
                      messages="Tarif de cette formule indiquée sur le devis (déplacements inclus)"
                      v-model="formData['tarif']"
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" md="6">
                    <v-textarea
                    auto-grow
                    rows="1"
                      hide-details="auto"
                      outlined
                      messages="S’agit-il d’une surprise pour l’un des mariés, les invités :"
                      v-model="formData['surprise']"
                      required
                    ></v-textarea>
                  </v-col> -->
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-card flat>
            <v-card-text>
              <v-row>
                <!-- date -->
                <v-col cols="12" md="6">
                  <v-text-field
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    type="date"
                    v-model="formData.date"
                    messages="Date de la cérémonie:"
                  ></v-text-field>
                </v-col>
                <!-- Nom de la ville:  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Nom de la ville: "
                    v-model="formData['nomVille']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Code postal de cette commune:  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Code postal de cette commune: "
                    v-model="formData['cp']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Type de lieu de la cérémonie (église, domaine, mairie,..):  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Type de lieu de la cérémonie (église, domaine, mairie,..):"
                    v-model="formData['lieuCérémonie']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Lien Google Maps du lieu de la prestation (important):-->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Lien Google Maps du lieu de la prestation (important): "
                    v-model="formData['lienGoogleMapslieuCérémonie']"
                    required
                  ></v-textarea>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.google.fr/maps"
                    >Accéder à google maps</a
                  >
                </v-col>
                <!-- Adresse précise du lieu de la cérémonie (pour vérification) :  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Adresse précise du lieu de la cérémonie (pour vérification)"
                    v-model="formData['AdresselieuCérémonie']"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-card flat>
            <v-card-text>
              <v-row>
                <!-- Personne référente (autre que vous) qui recevra un SMS pour informer de l’arrivée du groupe:  -->
                <v-col cols="12">
                  <p class="mx-5">
                    Personne référente (autre que vous) qui recevra un SMS pour informer de
                    l’arrivée du groupe:
                  </p>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Nom-Prénom"
                    v-model="formData['personneRefNomPrenom']"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Tél mobile"
                    v-model="formData['personneRefTel']"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Quel lien familial/amical: "
                    v-model="formData['personneRefLien']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Heure précise du début de l’événement (le groupe arrivera 90 min avant) :   -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Heure précise du début de l’événement (le groupe arrivera 90 min avant) :  "
                    v-model="formData['heureDebEven']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Quelle sera la durée de la cérémonie -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Si vous avez une wedding planner, nous indiquer son nom, mail, téléphone:"
                    v-model="formData['dureeCer']"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :items="['Mariage', 'Baptême', 'Animation cocktail']"
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Type de cérémonie :"
                    v-model="formData['typeCer']"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="5">
          <v-card flat>
            <v-card-text>
              <v-row>
                <!-- Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) :  -->
                <v-col cols="12" md="6">
                  <!-- <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) :"
                    v-model="formData['tenues']"
                    required
                  ></v-textarea> -->
                  <v-select
                    :items="['Toges', 'En noir']"
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) :"
                    v-model="formData['tenues']"
                    required
                  ></v-select>
                </v-col>
                <!-- S’agit-il d’une surprise pour l’un des mariés:  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="S’agit-il d’une surprise pour l’un des mariés:"
                    v-model="formData['surprise']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Nombre d’invités attendus:  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Nombre d’invités attendus:"
                    v-model="formData['nbInvites']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- Avez-vous d’autres demandes ou suggestions artistiques à proposer au groupe:  -->
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Avez-vous d’autres demandes ou suggestions artistiques à proposer au groupe:"
                    v-model="formData['autresDemandes']"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  Si cérémonie avec 200 invités en intérieur ou tout simplement en extérieur, une
                  sonorisation est nécessaire. Le groupe peut la gérer lui-même pour un léger
                  supplément (contacter Virginie au 07 68 88 94 36).<br />Autrement merci de nous
                  donner les précisions suivantes :
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Quel est le contact de la personne qui devra mettre en place et gérer la sonorisation durant toute la prestation du groupe:"
                    v-model="formData.nomPerGerSono"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6">
                  <v-textarea
                    auto-grow
                    rows="1"
                    hide-details="auto"
                    outlined
                    messages="Cette personne a-t-elle confirmé qu’elle respectera parfaitement la fiche technique ? :"
                    v-model="formData['confRespFichTechSono']"
                    required
                  ></v-textarea>
                </v-col>
                <!-- <v-col cols="12" md="6">
                  <v-textarea
                  auto-grow
                  rows="1"
                    hide-details="auto"
                    outlined
                    messages="Nom Client Comptable"
                    v-model="formData['Nom Client Comptable']"
                  ></v-textarea>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="6">
          <v-card>
            <v-card-text>
              <!-- <div>
                <p align="JUSTIFY">
                  La SARL SAY PRODUCTION (nom de marque GOSPEL EVENT), au capital de 5.000 &euro;,
                  No de Siret 512 972 803 000 13. Code APE : 9001 Z, dont le si&egrave;ge est
                  situ&eacute; au 45 grand rue, 34260 CEILHES, r&eacute;alise des prestations de
                  &nbsp;chants Gospel pour c&eacute;r&eacute;monies et concerts. Vous pouvez nous
                  joindre au 07 68 88 94 36‬, ou par mail &agrave; virginie.gospelevent@icloud.com
                </p>
                <p align="JUSTIFY">
                  D&egrave;s r&eacute;ception de votre commande<strong>,&nbsp;</strong>nous la
                  v&eacute;rifions et nous la transmettons imm&eacute;diatement au coordinateur du
                  groupe que vous souhaitez r&eacute;server.
                </p>

                <p align="JUSTIFY">
                  Si ce groupe ne peut valider votre bon de commande, celui-ci sera automatiquement
                  annul&eacute; mais nous pourrons si vous le souhaitez, vous aider &agrave;
                  r&eacute;server un autre groupe.<br />Si le groupe valide, nous vous attestons
                  cela par retour de mail. Ce bon de commande sera ensuite sign&eacute;
                  &eacute;lectroniquement, nous engageant fermement mutuellement pour la prestation.
                </p>
                <p align="JUSTIFY">
                  La prestation sera compos&eacute;e de maximum 7 chants. Le nombre sera notamment
                  d&eacute;termin&eacute; par le plan de messe n&eacute;goci&eacute; entre vous et
                  l&rsquo;officiant.
                </p>
                <p align="JUSTIFY">
                  Si le jour de la c&eacute;r&eacute;monie doit commencer avec plus de 30 minutes de
                  retard par rapport &agrave; l&rsquo;heure convenue initialement sur le bon de
                  commande, les artistes pourront n&eacute;gocier aupr&egrave;s de vous une
                  r&eacute;duction de la dur&eacute;e des chants ou supprimer certaines chansons.
                  Ceci devant alors avoir lieu avec le maximum de concertation et de courtoisie avec
                  vous.
                </p>

                <p align="JUSTIFY">
                  En cas de changement d&rsquo;heure de la c&eacute;l&eacute;bration, vous vous
                  engagez &agrave; informer au plus t&ocirc;t Gospel Event par mail, qui devra
                  valider le nouvel horaire par retour de mail. Si ce changement d&rsquo;horaire
                  entra&icirc;ne trop de contraintes pour les artistes (par exemple :
                  Impossibilit&eacute; d&rsquo;assurer un autre contrat pr&eacute;vu en
                  soir&eacute;e le m&ecirc;me jour), Gospel Event pourra refuser ce changement
                  d&rsquo;heure, ceci entra&icirc;nant une rupture de contrat de la part du client.
                  Comme toujours, un arrangement &agrave; l&rsquo;amiable sera
                  privil&eacute;gi&eacute;.
                </p>

                <p class="red--text">
                  <strong>Votre r&egrave;glement :</strong><br />Il se fait par
                  pr&eacute;l&egrave;vement, jusque 3 fois maximum sans frais avant la
                  prestation.<br />Un acompte de 30% devra &ecirc;tre r&eacute;gl&eacute; par
                  pr&eacute;l&egrave;vement sous 10 jours apr&egrave;s r&eacute;ception de votre
                  commande.&nbsp;<br />Si cet acompte est rejet&eacute; par votre banque, ce bon de
                  commande sera annul&eacute;. Deux autres pr&eacute;l&egrave;vements interviennent
                  comme suit <strong>:</strong> 40% quatre mois avant
                  l&rsquo;&eacute;v&eacute;nement et 30% un mois avant.
                </p>
                <p align="JUSTIFY" class="red--text">
                  Exemple : prestation &agrave; 1099&euro; = 329,70&euro; &agrave; la commande,
                  439,60&euro; quatre mois avant, 329,70&euro; un mois avant.&nbsp;
                </p>
                <p>
                  Nous respecterons scrupuleusement les dates que vous nous aurez indiqu&eacute;es,
                  et que nous pourrons changer &agrave; tout moment &agrave; votre demande.
                </p>
                <p>
                  En cas de pr&eacute;l&egrave;vement rejet&eacute;, les frais bancaires de 10&euro;
                  appliqu&eacute;s par notre banque seront ajout&eacute;s &agrave; votre prochain
                  pr&eacute;l&egrave;vement.
                </p>
                <p>
                  Deux jours apr&egrave;s votre c&eacute;r&eacute;monie nous vous contacterons par
                  t&eacute;l&eacute;phone pour nous assurer de votre enti&egrave;re satisfaction.
                </p>

                <p align="JUSTIFY">
                  Par l&rsquo;envoi de ce bon de commande, vous attestez &eacute;galement que votre
                  officiant accepte l&rsquo;intervention du groupe et que vous serez en mesure de
                  pr&eacute;parer votre r&eacute;pertoire (&agrave; inclure dans le plan de
                  c&eacute;r&eacute;monie) au plus tard 2 mois avant
                  l&rsquo;&eacute;v&eacute;nement, ceci afin d&rsquo;&eacute;viter une
                  pr&eacute;paration trop pr&eacute;cipit&eacute;e.
                </p>
                <p align="JUSTIFY">
                  Si l&rsquo;officiant devait &agrave; un moment des pr&eacute;paratifs ou de la
                  c&eacute;r&eacute;monie, revoir le nombre de chants ou leur dur&eacute;e, ceci ne
                  saurait constituer une condition d&rsquo;annulation de commande.
                </p>

                <p align="JUSTIFY">
                  Si &agrave; la suite de l&rsquo;&eacute;v&eacute;nement, des amis ou des
                  connaissances demandent le contact du groupe, le client s&rsquo;engage &agrave;
                  fournir uniquement le contact du site web Gospel Event : www.gospel-event.com
                </p>

                <p align="JUSTIFY">
                  <strong>En cas de report de votre &eacute;v&eacute;nement :</strong><br />Les
                  acomptes restent acquis &agrave; Gospel Event. Vous disposez de 6 mois pour nous
                  indiquer la nouvelle date de la prestation.
                </p>

                <p align="JUSTIFY">
                  <strong>En cas de demande d&rsquo;annulation de cette commande :</strong><br />.
                  Gospel Event n&rsquo;a jamais annul&eacute; une prestation. Toutefois afin de vous
                  s&eacute;curiser, si cela devait arriver nous nous engageons &eacute;videment
                  &agrave; vous r&eacute;troc&eacute;der vos r&egrave;glements d&eacute;j&agrave;
                  effectu&eacute;s, mais &eacute;galement &agrave; vous d&eacute;dommager
                  d&rsquo;une somme &eacute;gale au montant de la prestation annonc&eacute;e en
                  premi&egrave;re page de ce bon de commande.<br />. Si vous souhaitez annuler
                  vous-m&ecirc;me cette commande, et que votre demande d&rsquo;annulation nous
                  parvient plus de quatre mois avant la date de votre &eacute;v&eacute;nement, votre
                  commande sera simplement annul&eacute;e. Il vous suffit d&rsquo;obtenir un
                  accus&eacute; de r&eacute;ception par mail de notre part. Toutefois les 30%
                  d&eacute;j&agrave; per&ccedil;us ne vous seront pas rembours&eacute;s.<br />. Si
                  votre demande d&rsquo;annulation nous parvient moins de quatre mois avant la date
                  de votre &eacute;v&eacute;nement, vous nous serez redevable d&rsquo;une somme de
                  d&eacute;dommagement du montant int&eacute;gral de cette prestation (moins les
                  frais de d&eacute;placements).
                </p>
                <p align="JUSTIFY">
                  . En cas d&rsquo;annulation reconnue de force majeure, la prestation sera
                  annul&eacute;e et rembours&eacute;e seulement si vous pouvez apporter la preuve
                  formelle qu&rsquo;un report est impossible.
                </p>
                <p align="JUSTIFY">
                  En cas de litige portant sur l&rsquo;interpr&eacute;tation ou l&rsquo;application
                  de cette commande :
                </p>
                <p align="JUSTIFY">
                  les parties conviennent de s&rsquo;en remettre &agrave;
                  l&rsquo;appr&eacute;ciation du Tribunal de Montpellier.&nbsp;
                </p>
              </div> -->
              <div class="subpage">
                <p class="c0">
                  <br />La SARL SAY PRODUCTION (nom de marque GOSPEL EVENT), au capital de 5.000 €,
                  No de Siret 512 972 803 000 13, dont le siège est situé au 45
                  grand rue, 34260 CEILHES, réalise des prestations de chants Gospel pour cérémonies
                  et concerts. Vous pouvez nous joindre au 07 68 88 94 36‬, ou par mail à
                  virginie.gospelevent@icloud.com <br /><br />Dès réception de votre commande, nous
                  la vérifions et nous la transmettons immédiatement au coordinateur du groupe que
                  vous souhaitez réserver.

                  <br /><br />Si ce groupe ne peut valider votre bon de commande, celui-ci sera
                  automatiquement annulé mais nous pourrons si vous le souhaitez, vous aider à
                  réserver un autre groupe. <br />Si le groupe valide, nous vous attestons cela par
                  retour de mail. Ce bon de commande sera ensuite signé électroniquement, nous
                  engageant fermement mutuellement pour la prestation.

                  <br /><br />La prestation sera composée de maximum 7 chants. Le nombre sera
                  notamment déterminé par le plan de messe négocié entre vous et l’officiant. Le
                  groupe ne prendra pas en charge les chants religieux en français.

                  <br /><br />Si le jour de la cérémonie doit commencer avec plus de 30 minutes de
                  retard par rapport à l’heure convenue initialement sur le bon de commande, les
                  artistes pourront négocier auprès de vous une réduction de la durée des chants ou
                  supprimer certaines chansons. Ceci devant alors avoir lieu avec le maximum de
                  concertation et de courtoisie avec vous.

                  <br /><br />En cas de changement d’heure de la célébration, vous vous engagez à
                  informer au plus tôt Gospel Event par mail, qui devra valider le nouvel horaire
                  par retour de mail. Si ce changement d’horaire entraîne trop de contraintes pour
                  les artistes (par exemple : Impossibilité d’assurer un autre contrat prévu en
                  soirée le même jour), Gospel Event pourra refuser ce changement d’heure, ceci
                  entraînant une rupture de contrat de la part du client. Comme toujours, un
                  arrangement à l’amiable sera privilégié. <br /><br />En cas de pluie pendant une
                  cérémonie en extérieur, les artistes devront interrompre leur prestation pour
                  mettre leur matériel à l’abri. La pluie n’étant pas une cause d’annulation, car
                  vous êtes censé avoir prévu un lieu de repli pour poursuivre votre cérémonie.
                  <br />
                  <br />
                  <span class="c76 c60" style="color: red">Votre règlement :</span
                  ><span class="c35 c79 c60" style="color: red"
                    >&nbsp; <br />Il se fait par prélèvement, jusque 3 fois maximum sans frais avant
                    la prestation. <br />Un acompte de 30% devra être réglé par prélèvement sous 10
                    jours après réception de votre commande. Deux autres prélèvements interviennent
                    comme suit : 40% quatre mois avant l’événement et 30% un mois avant.
                    <br />Exemple : prestation à 1099€ = 329,70€ à la commande, 439,60€ quatre mois
                    avant, 329,70€ un mois avant.<br />
                    Nous respecterons scrupuleusement les dates que vous nous aurez indiquées, 
                    et que nous pourrons changer à tout moment à votre demande.
                  </span>
                  <br /><br />Si un prélèvement est rejeté par votre banque, nous vous
                  recontacterons au plus vite pour convenir ensemble d’une autre date de
                  prélèvement. Un prélèvement rejeté entraine des frais bancaires de 10€ appliqués
                  par notre banque, qui seront ajoutés à votre prochain prélèvement.<br />
                  Sans nouvelle de votre part suite à ce rejet, et si nous ne trouvons pas de solution 
                  à l’amiable, cette prestation sera considérée comme étant annulée de votre fait, 
                  et les conditions d’annulation ci-dessous s’appliqueront.
                  <br /><br />Nous respecterons scrupuleusement les dates que vous nous aurez
                  indiquées, et que nous pourrons changer à tout moment à votre demande.
                  <br /><br />Deux jours après votre cérémonie nous vous contacterons par téléphone
                  pour nous assurer de votre entière satisfaction. <br /><br />Par l’envoi de ce bon
                  de commande, vous attestez également que votre officiant accepte l’intervention du
                  groupe et que vous serez en mesure de préparer votre répertoire (à inclure dans le
                  plan de cérémonie) au plus tard 2 mois avant l’événement, ceci afin d’éviter une
                  préparation trop précipitée. <br /><br />Si l’officiant devait à un moment des
                  préparatifs ou de la cérémonie le jour J, revoir le nombre de chants ou leur
                  durée, ceci ne saurait constituer une condition d’annulation de commande.
                  <br /><br />Si à la suite de l’événement, des amis ou des connaissances demandent
                  le contact du groupe, le client s’engage à fournir uniquement le lien du site web
                  Gospel Event : www.gospel-event.com <br /><br /><strong
                    >En cas de report de votre événement :</strong
                  >
                  <br />Les règlements reçus restent acquis à Gospel Event. Vous disposez de 6 mois
                  pour nous indiquer la nouvelle date de la prestation. <br /><strong
                    >En cas de demande d’annulation de cette commande :</strong
                  >
                  <br />. Gospel Event n’a jamais annulé une prestation. Toutefois afin de vous
                  sécuriser, si cela devait arriver nous nous engageons évidement à vous rétrocéder
                  vos règlements déjà effectués, mais également à vous dédommager d’une somme égale
                  au montant de la prestation annoncée en première page de ce bon de commande.
                  <br />. Si vous souhaitez annuler vous-même cette commande, et que votre demande
                  d’annulation nous parvient plus de quatre mois avant la date de votre événement,
                  votre commande sera annulée. Il vous suffit d’obtenir un accusé de réception par
                  mail de notre part. Toutefois les 30% déjà perçus ne vous seront pas remboursés.
                  <br />. Si votre demande d’annulation nous parvient moins de quatre mois avant la
                  date de votre événement, vous nous serez redevable d’une somme de dédommagement du
                  montant intégral de cette prestation (moins les frais de déplacements). <br />. En
                  cas d’annulation reconnue de « force majeure », la prestation sera annulée et
                  remboursée seulement si vous pouvez apporter la preuve formelle qu’un report est
                  impossible. <br /><br />En cas de litige portant sur l’interprétation ou
                  l’application de cette commande : les parties conviennent de s’en remettre à
                  l’appréciation du Tribunal de Montpellier.
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="7">
          <v-card>
            <v-card-text class="text-center">
              <v-container>
                <span>
                  (Numéro ICS de Say Production délivré par les autorités bancaires de France :
                  FR03ZZZ856E67)
                </span>
                <p class="text-justify">
                  En complétant le formulaire ci-dessous, qui tient lieu de mandat de prélèvement
                  SEPA, et en nous le retournant par mail dans ce bon de commande, cela vous revient
                  à signer électroniquement cette autorisation de prélèvement.
                </p>
                <p class="text-justify">
                  À aucun moment Say Production ne pourra déroger aux informations complétées
                  ci-dessous par vos soins, en procédant par exemple à une demande de prélèvement
                  avec une autre somme ou en décalant une date, sous peine de poursuite.
                </p>
                <p class="text-justify">
                  À tout moment vous pouvez également nous contacter pour modifier cette
                  autorisation de prélèvement.
                </p>

                <v-textarea
                  auto-grow
                  rows="1"
                  class="mt-5"
                  hide-details="auto"
                  outlined
                  messages="ADRESSE MAIL DU DÉTENTEUR DU COMPTE :"
                  v-model="formData['emailIban']"
                  required
                ></v-textarea>
                <v-textarea
                  auto-grow
                  rows="1"
                  class="mt-5"
                  hide-details="auto"
                  outlined
                  messages="NOM DE LA PERSONNE DÉBITÉE :"
                  v-model="formData['nomDeLaPersIban']"
                  required
                ></v-textarea>
                <v-textarea
                  auto-grow
                  rows="1"
                  class="mt-5"
                  hide-details="auto"
                  outlined
                  messages="PRÉNOM DE LA PERSONNE :"
                  v-model="formData['prenomDeLaPersIban']"
                  required
                ></v-textarea>
                <v-textarea
                  auto-grow
                  rows="1"
                  class="mt-5"
                  hide-details="auto"
                  outlined
                  messages="SON ADRESSE POSTALE :"
                  v-model="formData['adresseDeLaPersIban']"
                  required
                ></v-textarea>

                <p class="text-justify">
                  <strong>autorise la sarl Say Production – Gospel Event</strong> , basée au 45
                  grand rue, 34260 Ceilhes, à envoyer des instructions à votre banque pour débiter
                  le compte courant ci-dessous :
                </p>

                <v-textarea
                  auto-grow
                  rows="1"
                  hide-details="auto"
                  outlined
                  messages="IBAN DU COMPTE COURANT (sans espace)"
                  v-model="formData['iban']"
                  required
                ></v-textarea>
                <br />
                <v-chip-group
                  v-model="formData.reglementType23"
                  column
                  active-class="primary--text"
                  @change="calculDuPrix($event)"
                >
                  <v-chip value="-1"> RÈGLEMENT EN 1 FOIS </v-chip>
                  <v-chip value="0"> RÈGLEMENT EN 2 FOIS </v-chip>
                  <v-chip value="1"> RÈGLEMENT EN 3 FOIS </v-chip>
                </v-chip-group>
                <div v-if="formData.reglementType23 !== undefined">
                  <!-- RÈGLEMENT EN 1 FOIS -->
                  <div
                    v-if="formData.reglementType23 == '-1'"
                    style="max-width: 500px"
                    class="d-flex flex-column justify-content-center mx-auto"
                  >
                    <v-simple-table style="width: 100%">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th colspan="4" class="text-center">
                              <div class="text-h6">RÈGLEMENT EN 1 FOIS</div>
                              <!-- <div class="text-subtitle-1">
                                montants et dates modifiables par vos soins
                              </div> -->
                            </th>
                          </tr>
                          <tr>
                            <th class="text-left" style="width: 35%"></th>
                            <th class="text-center" style="width: 25%">MONTANT</th>
                            <th class="text-center" style="width: 20%">MOIS</th>
                            <th class="text-center" style="width: 20%">ANNÉE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-left">100% (à la commande)</td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                append-icon="mdi-pencil"
                                solo
                                v-model="formData['MONTANT100']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                append-icon="mdi-pencil"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                v-model="formData['MOIS100']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                append-icon="mdi-pencil"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                v-model="formData['ANNÉE100']"
                              ></v-text-field>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <!-- cases -->
                  </div>
                  <!-- RÈGLEMENT EN 2 FOIS -->
                  <div
                    v-if="formData.reglementType23 == '0'"
                    style="max-width: 500px"
                    class="d-flex flex-column justify-content-center mx-auto"
                  >
                    <v-simple-table style="width: 100%">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th colspan="4" class="text-center">
                              <div class="text-h6">RÈGLEMENT EN 2 FOIS</div>
                              <div class="text-subtitle-1">
                                montants et dates modifiables par vos soins
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <th class="text-left" style="width: 35%"></th>
                            <th class="text-center" style="width: 25%">MONTANT</th>
                            <th class="text-center" style="width: 20%">MOIS</th>
                            <th class="text-center" style="width: 20%">ANNÉE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-left">Acompte 30% (à la commande)</td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                append-icon="mdi-pencil"
                                solo
                                v-model="formData['MONTANT30']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                append-icon="mdi-pencil"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                v-model="formData['MOIS30']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                append-icon="mdi-pencil"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                v-model="formData['ANNÉE30']"
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">Solde 70% (4 mois avant l’événement)</td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                append-icon="mdi-pencil"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                v-model="formData['MONTANT70']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                append-icon="mdi-pencil"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                v-model="formData['MOIS70']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                append-icon="mdi-pencil"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                v-model="formData['ANNÉE70']"
                              ></v-text-field>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <!-- cases -->
                  </div>

                  <!-- RÈGLEMENT EN 3 FOIS -->
                  <div
                    v-if="formData.reglementType23 == '1'"
                    style="max-width: 500px"
                    class="d-flex flex-column justify-content-center mx-auto"
                  >
                    <v-simple-table style="width: 100%">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th colspan="4" class="text-center">
                              <div class="text-h6">RÈGLEMENT EN 3 FOIS</div>
                              <div class="text-subtitle-1">
                                montants et dates modifiables par vos soins
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <th class="text-left" style="width: 35%"></th>
                            <th class="text-center" style="width: 25%">MONTANT</th>
                            <th class="text-center" style="width: 20%">MOIS</th>
                            <th class="text-center" style="width: 20%">ANNÉE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-left">
                              <span> Acompte 30% <br />(à la commande)</span>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                append-icon="mdi-pencil"
                                solo
                                v-model="formData['MONTANT303']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                append-icon="mdi-pencil"
                                v-model="formData['MOIS303']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                append-icon="mdi-pencil"
                                v-model="formData['ANNÉE303']"
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">Solde 40% <br />(4 mois avant l’événement)</td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                append-icon="mdi-pencil"
                                v-model="formData['MONTANT403']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                append-icon="mdi-pencil"
                                v-model="formData['MOIS403']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                append-icon="mdi-pencil"
                                v-model="formData['ANNÉE403']"
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">Solde 30% <br />(1 mois avant l'événement)</td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                append-icon="mdi-pencil"
                                v-model="formData['MONTANT30_3']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                solo
                                append-icon="mdi-pencil"
                                v-model="formData['MOIS30_3']"
                              ></v-text-field>
                            </td>
                            <td class="text-left">
                              <v-text-field
                                class="centered-input"
                                auto-grow
                                rows="1"
                                hide-details="auto"
                                append-icon="mdi-pencil"
                                solo
                                v-model="formData['ANNÉE30_3']"
                              ></v-text-field>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <!-- cases -->
                  </div>
                  <v-select
                    class="mt-3"
                    outlined
                    v-model="formData['datePrelevement']"
                    :items="$store.state.datesPrelevement"
                    messages="Choisissez le jour le jour souhaité de vos prélèvements dans la liste"
                  >
                  </v-select>
                </div>
                <br />

                <v-text-field
                  rows="1"
                  class="mt-5"
                  messages="Document complété le :"
                  v-model="formData['documentComplLe']"
                  outlined
                  type="date"
                ></v-text-field>
                <v-text-field
                  rows="1"
                  class="mt-5"
                  v-model="formData['à']"
                  messages="à :"
                  outlined
                ></v-text-field>
              </v-container>
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="8">
          <v-card>
            <v-card-text class="text-center my-5">
              Merci de vérifier l'exactitude des informations saisies 👌
            </v-card-text>
            <v-list-item-group color="primary">
              <template v-for="(item, i) in formData">
                <v-list-item
                  :key="i"
                  v-if="VarLab.map((e) => e.nomVariable).indexOf(i) !== -1 && item !== ' '"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="
                        VarLab.map((e) => e.label)[VarLab.map((e) => e.nomVariable).indexOf(i)]
                      "
                    ></v-list-item-title>
                    <v-list-item-subtitle>{{ testIfitIsADate(item) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="9">
          <v-card>
            <v-card-text class="text-center my-5">
              Merci beaucoup pour ce bon de commande, <br />
              vous serez recontacté très prochainement 👏
            </v-card-text>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="10"> </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-row class="mt-5">
      <v-col class="text-center mb-6 px-0" v-if="formData.e6 !== 9">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading && userSaving"
          x-small
          v-if="formData.e6 !== '' && formData.e6 !== '1'"
          @click="testIfFirstTimeSaveAndSendEmail()"
          text
          color="grey"
        >
          <div>
            <span class="first-line">Enregistrer pour</span><br />
            <span class="second-line">plus tard</span>
          </div>
          <!-- <div v-else>
            <span class="first-line">Enregistré</span>
          </div> -->
        </v-btn>

        <v-btn class="mr-2" small v-if="formData.e6 !== ''" text @click="goBack"> Retour </v-btn>
        <v-btn v-if="formData.e6 !== 8" small color="primary" @click="goNext"> Suivant </v-btn>
        <!-- <v-btn v-if="formData.e6 == 1" small color="primary" @click="sendEmailToUserToResume()">
          Suivant
        </v-btn> -->
        <v-btn v-if="formData.e6 == 8" small color="primary" @click="sendFinalBDC()">
          Envoyer
        </v-btn>
      </v-col>
      <v-col class="text-center mb-6" v-else>
        <v-spacer></v-spacer>

        <v-btn
          v-if="admin"
          small
          color="primary"
          @click="
            printDiv2(
              'toPrint',
              `BDC Cérémonie ${formatDate(formData.date)} ${formData.nomVille} ${formData.groupe}`
            )
          "
        >
          Telecharger mon BDC
        </v-btn>
        <!-- <v-btn small color="primary" @click="printDiv2('toPrint')"> Telecharger mon BDC </v-btn> -->
      </v-col>
    </v-row>
    <pdf-to-print id="toPrint" style="display: none" :data="formData"></pdf-to-print>
    <!-- <pdf-to-print id="toPrint" style="display: block" :data="formData"></pdf-to-print> -->
    <v-snackbar v-model="snackbar" :timeout="timeout" color="primary">
      {{ text }}
    </v-snackbar>
  </v-form>
</template>

<script>
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import pdfToPrint from "./Pdf.vue";
// import { query } from "@firebase/firestore";
export default {
  components: { pdfToPrint },
  props: {
    // url_data,
  },
  async mounted() {
    var id = this.$route.query.id;
    console.log(this.$route);
    if (id !== undefined) {
      this.currentUserId = id;
      this.getDataOfExistingUser(id);
    } else {
      // create new user id and save it in bdd
      this.currentUserId = this.generateNewUserId();
      this.createNewUserInBDD();
    }
    var admin = this.$route.query.admin;
    if (admin == "true") {
      this.admin = true;
    }

    // firs
    var vm = this;
    this.intervalId = window.setInterval(function () {
      /// call your function here
      if (vm.dataChange) {
        vm.saveCurrentData();
      }
    }, 10000);
  },
  beforeUpdate() {
    clearInterval(this.intervalId);
  },
  updated() {
    var vm = this;
    this.intervalId = window.setInterval(function () {
      /// call your function here
      // console.log("save every 10 second");
      if (vm.dataChange) {
        vm.saveCurrentData();
      }
    }, 10000);
  },
  data: () => ({
    userSaving: false,
    admin: false,
    snackbar: false,
    text: "Nous vous avons envoyé un e-mail 😉",
    timeout: 2000,
    intervalId: "",
    reglementType23: undefined,
    emailSent: false,
    currentUserId: "",
    loading: false,
    tmpLastChange: "",
    tmpLastSave: "",
    dataChange: false,
    formules: [
      "1 choriste + 1 pianiste",
      "2 choristes dont 1 pianiste",
      "2  choristes + 1 pianiste",
      "3 choristes a capella",
      "3 choristes dont 1 pianiste",
      "3  choristes + 1 pianiste",
      "4 choristes a capella",
      "4 choristes dont  1 pianiste",
      "4 choristes + 1 pianiste",
      "5 choristes a capella",
      "5 choristes dont un pianiste",
      "5 choristes + 1 pianiste",
      "autre formule avec plus d'artiste",
    ],
    formData: {
      Nom: " ",
      Prénom: " ",
      adressePostaleParticulier: " ",
      mail: null,
      Siret: " ",
      CodeAPE: " ",
      nomDeLaStructure: " ",
      tel: " ",
      représentant: " ",
      Adresse: " ",
      telFixe: " ",
      telMob: " ",
      groupe: null,
      nbChanteurs: null,
      tarif: null,
      surprise: null,
      nomVille: null,
      date: "",
      cp: null,
      lieuCérémonie: null,
      lienGoogleMapslieuCérémonie: null,
      AdresselieuCérémonie: null,
      personneRefNomPrenom: null,
      personneRefTel: null,
      personneRefLien: null,
      heureDebEven: null,
      dureeCer: null,
      typeCer: "",
      tenues: null,
      nbInvites: null,
      autresDemandes: null,
      reglementType23: undefined,
      confRespFichTechSono: "",
      nomPerGerSono: "",
      nomDeLaPersIban: "",
      prenomDeLaPersIban: "",
      adresseDeLaPersIban: "",
      iban: "",
      e6: "",
      id: "",
      type: 0,
      Origine: null,
      //
      datePrelevement: "",
      //
      MONTANT100: " ",
      MOIS100: " ",
      ANNÉE100: " ",
      //
      MOIS30: " ",
      ANNÉE30: " ",
      MONTANT70: " ",
      MOIS70: " ",
      ANNÉE70: " ",
      //
      MONTANT303: " ",
      MOIS303: " ",
      ANNÉE303: " ",
      MONTANT403: " ",
      MOIS403: " ",
      ANNÉE403: " ",
      MONTANT30_3: " ",
      MOIS30_3: " ",
      ANNÉE30_3: " ",
      documentComplLe: "",
      à: null,
      emailSent: "",
    },
    VarLab: [
      { nomVariable: "Nom", label: "Nom" },
      { nomVariable: "Prénom", label: "Prénom" },
      { nomVariable: "adressePostaleParticulier", label: "Votre adresse postale" },
      { nomVariable: "tel", label: "Numéro de téléphone" },
      { nomVariable: "mail", label: "E-mail" },
      { nomVariable: "nomDeLaStructure", label: "Nom de la structure" },
      { nomVariable: "Siret", label: "Siret" },
      // { nomVariable: "CodeAPE", label: "Code APE" },
      { nomVariable: "représentant", label: "Représentée par (en sa qualité de)" },
      { nomVariable: "Adresse", label: "Adresse postale de correspondance" },
      { nomVariable: "telFixe", label: "Numéro de téléphone fixe" },
      { nomVariable: "telMob", label: "Numéro de téléphone mobile " },
      { nomVariable: "mail", label: "E-mail" },
      { nomVariable: "groupe", label: "Nom du groupe de Gospel que vous souhaitez retenir" },
      { nomVariable: "nbChanteurs", label: "Combien de chanteurs et musiciens souhaités" },
      {
        nomVariable: "tarif",
        label: "Tarif de cette formule indiquée sur le devis (déplacements inclus)",
      },
      {
        nomVariable: "surprise",
        label: "S’agit-il d’une surprise pour l’un des mariés, les invités",
      },
      { nomVariable: "date", label: "Date de la cérémonie" },
      { nomVariable: "nomVille", label: "Nom de la ville" },
      { nomVariable: "cp", label: "Code postal de cette commune" },
      {
        nomVariable: "lieuCérémonie",
        label: "Type de lieu de la cérémonie (église, domaine, mairie,..)",
      },
      {
        nomVariable: "lienGoogleMapslieuCérémonie",
        label: "Lien Google Maps du lieu de la prestation (important)",
      },
      {
        nomVariable: "AdresselieuCérémonie",
        label: "Adresse précise du lieu de la cérémonie (pour vérification)",
      },
      { nomVariable: "personneRefNomPrenom", label: "Nom-Prénom" },
      { nomVariable: "personneRefTel", label: "Tél mobile" },
      { nomVariable: "personneRefLien", label: "Quel lien familial/amical" },
      {
        nomVariable: "heureDebEven",
        label: "Heure précise du début de l’événement (le groupe arrivera 90 min avant)",
      },
      {
        nomVariable: "dureeCer",
        label: "Si vous avez une wedding planner, nous indiquer son nom, mail, téléphone",
      },
      { nomVariable: "typeCer", label: "Type de cérémonie" },
      {
        nomVariable: "tenues",
        label: "Tenues souhaitées pour le groupe (toges gospel OU tenues noires de soirée) ",
      },
      { nomVariable: "surprise", label: "S’agit-il d’une surprise pour l’un des mariés" },
      { nomVariable: "nbInvites", label: "Nombre d’invités attendus" },
      {
        nomVariable: "autresDemandes",
        label: "Avez-vous d’autres demandes ou suggestions artistiques à proposer au groupe",
      },
      {
        nomVariable: "nomPerGerSono",
        label:
          "Quel est nom et le contact de la personne qui devra mettre en place et gérer la sonorisation durant toute la prestation du groupe",
      },
      {
        nomVariable: "confRespFichTechSono",
        label:
          "Cette personne a-t-elle confirmé qu’elle respectera parfaitement la fiche technique ?",
      },
      {
        nomVariable: "emailIban",
        label: "ADRESSE MAIL DU DÉTENTEUR DU COMPTE",
      },
      { nomVariable: "nomDeLaPersIban", label: "NOM DE LA PERSONNE DÉBITÉE" },
      { nomVariable: "prenomDeLaPersIban", label: "PRÉNOM DE LA PERSONNE" },
      { nomVariable: "adresseDeLaPersIban", label: "SON ADRESSE POSTALE" },
      {
        nomVariable: "iban",
        label: "IBAN DU COMPTE COURANT (sans espace)",
      },
      { nomVariable: "datePrelevement", label: "Date de prélèvement" },
      //
      { nomVariable: "MONTANT100", label: "Montant 100% (à la commande)" },
      { nomVariable: "MOIS100", label: "Mois" },
      { nomVariable: "ANNÉE100", label: "Année" },
      //
      { nomVariable: "MONTANT30", label: "Montant Acompte 30% (à la commande)" },
      { nomVariable: "MOIS30", label: "Mois" },
      { nomVariable: "ANNÉE30", label: "Année" },
      { nomVariable: "MONTANT70", label: "Montant Acompte 70% (4 mois avant l’événement)" },
      { nomVariable: "MOIS70", label: "Mois" },
      { nomVariable: "ANNÉE70", label: "Année" },
      //
      { nomVariable: "MONTANT303", label: "Montant Acompte 30% (à la commande)" },
      { nomVariable: "MOIS303", label: "Mois" },
      { nomVariable: "ANNÉE303", label: "Année" },
      { nomVariable: "MONTANT403", label: "Montant Acompte 40% (4 mois avant l’événement)" },
      { nomVariable: "MOIS403", label: "Mois" },
      { nomVariable: "ANNÉE403", label: "Année" },
      { nomVariable: "MONTANT30_3", label: "Montant Acompte 30% (1 mois avant l’événement)" },
      { nomVariable: "MOIS30_3", label: "Mois" },
      { nomVariable: "ANNÉE30_3", label: "Année" },
      { nomVariable: "documentComplLe", label: "Document complété le" },
      { nomVariable: "à", label: "à" },
    ],

    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    menu: false,
    modal: false,

    selectedCommId: null,

    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],

    email1: "",
    emailRules1: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
  }),
  computed: {
    cgv() {
      return this.$store.state.cgv;
    },
    title() {
      var titre = "titre";
      if (this.formData.e6 == "") {
        titre = "Vous êtes ?";
      } else if (this.formData.e6 == 1) {
        titre = "VOS COORDONNÉES";
      } else if (this.formData.e6 == 2) {
        titre = "VOTRE GROUPE GOSPEL";
      } else if (this.formData.e6 == 3) {
        titre = "DATE ET LIEU DE L’ÉVÉNEMENT";
      } else if (this.formData.e6 == 4) {
        titre = "PRÉCISIONS LOGISTIQUES";
      } else if (this.formData.e6 == 5) {
        titre = "PRÉCISIONS LOGISTIQUES (fin)";
      } else if (this.formData.e6 == 6) {
        titre = "Conditions générales de vente";
      } else if (this.formData.e6 == 7) {
        titre = "AUTORISATION DE PRÉLÈVEMENT";
      } else if (this.formData.e6 == 8) {
        titre = "RECAP";
      } else if (this.formData.e6 == 9) {
        titre = "";
      }

      return titre;
    },
  },
  methods: {
    subtractMonths(date, months) {
      date.setMonth(date.getMonth() - months);
      return date;
    },
    calculDuPrix(type) {
      var prix = this.formData["tarif"];
      if (prix == "" || prix == null) {
        window.alert(
          "Vous n'avez pas renseigner le tarif de cette formule\nVous pouvez le faire à l'étape 2"
        );
        return;
      }
      if (this.formData.date == "" || this.formData.date == null) {
        window.alert(
          "Vous n'avez pas renseigner la date de la cérémonie:\nVous pouvez le faire à l'étape 3"
        );
        return;
      }
      prix = parseFloat(prix);
      var now = new Date();
      let month = now.getUTCMonth() + 1;
      let day = now.getUTCDate();
      let year = now.getUTCFullYear();

      console.log("formData.date", this.formData.date); // 2023-02-25
      var [y, m, d] = String(this.formData.date).split("-");

      var eventDate = this.subtractMonths(new Date(parseInt(y), parseInt(m) - 1, parseInt(d)), 4);
      var eventDate1 = this.subtractMonths(new Date(parseInt(y), parseInt(m) - 1, parseInt(d)), 1);
      console.log("this.formData.date     :  ", this.formData.date);
      console.log(
        "event Date             :  ",
        new Date(parseInt(y), parseInt(m) - 1, parseInt(d))
      );
      console.log("eventDate sub 4 months :  ", eventDate);
      console.log("eventDate1 sub 1 month :  ", eventDate1);
      let Eventmonth = eventDate.getUTCMonth() + 1;
      let Eventday = eventDate.getUTCDate();
      let Eventyear = eventDate.getUTCFullYear();
      let Eventmonth1 = eventDate1.getUTCMonth() + 1;
      let Eventday1 = eventDate1.getUTCDate();
      let Eventyear1 = eventDate1.getUTCFullYear();
      console.log(month, day, year);
      if (type == 0) {
        this.formData["MONTANT30"] = Number(prix * 0.3).toFixed(2);
        this.formData["MOIS30"] = day > 24 ? (month + 1 > 12 ? 1 : month + 1) : month;
        this.formData["ANNÉE30"] = day > 24 ? (month + 1 > 12 ? year + 1 : year) : year;
        this.formData["MONTANT70"] = Number(prix * 0.7).toFixed(2);
        this.formData["MOIS70"] =
          eventDate > now
            ? Eventday > 24
              ? Eventmonth + 1 > 12
                ? 1
                : Eventmonth + 1
              : Eventmonth
            : day > 24
            ? month + 1 > 12
              ? 1
              : month + 1
            : month;

        this.formData["ANNÉE70"] =
          eventDate > now
            ? Eventday > 24
              ? Eventmonth + 1 > 12
                ? Eventyear + 1
                : Eventyear
              : Eventyear
            : day > 24
            ? month + 1 > 12
              ? year + 1
              : year
            : year;
        if (this.formData["MOIS70"] == this.formData["MOIS30"]) {
          this.formData["MOIS70"] = this.formData["MOIS70"] + 1;
          if (this.formData["MOIS70"] == 13) {
            this.formData["MOIS70"] = 1;
            this.formData["ANNÉE70"] = this.formData["ANNÉE70"] + 1;
          }
        }
        this.formData["MONTANT303"] = 0;
        this.formData["MONTANT403"] = 0;
        this.formData["MONTANT30_3"] = 0;
        console.log(prix);

        console.log(type);

        // paiment en 2 fois vider le paiment en 3 fois et init le paiment 2 fois
      } else if (type == 1) {
        this.formData["ANNÉE30"] = "";
        this.formData["MOIS30"] = "";
        this.formData["MOIS70"] = "";
        this.formData["ANNÉE70"] = "";
        this.formData["MONTANT30"] = 0;
        this.formData["MOIS303"] = day > 24 ? (month + 1 > 12 ? 1 : month + 1) : month;
        this.formData["ANNÉE303"] = day > 24 ? (month + 1 > 12 ? year + 1 : year) : year;
        this.formData["MOIS403"] =
          eventDate > now
            ? Eventday > 24
              ? Eventmonth + 1 > 12
                ? 1
                : Eventmonth + 1
              : Eventmonth
            : day > 24
            ? month + 1 > 12
              ? 1
              : month + 1
            : month;

        this.formData["ANNÉE403"] =
          eventDate > now
            ? Eventday > 24
              ? Eventmonth + 1 > 12
                ? Eventyear + 1
                : Eventyear
              : Eventyear
            : day > 24
            ? month + 1 > 12
              ? year + 1
              : year
            : year;
        this.formData["MOIS30_3"] =
          eventDate1 > now
            ? Eventday1 > 24
              ? Eventmonth1 + 1 > 12
                ? 1
                : Eventmonth1 + 1
              : Eventmonth1
            : day > 24
            ? month + 1 > 12
              ? 1
              : month + 1
            : month;

        this.formData["ANNÉE30_3"] =
          eventDate1 > now
            ? Eventday1 > 24
              ? Eventmonth1 + 1 > 12
                ? Eventyear1 + 1
                : Eventyear1
              : Eventyear1
            : day > 24
            ? month + 1 > 12
              ? year + 1
              : year
            : year;
        if (this.formData["MOIS403"] == this.formData["MOIS303"]) {
          this.formData["MOIS403"] = this.formData["MOIS403"] + 1;
          if (this.formData["MOIS403"] == 13) {
            this.formData["MOIS403"] = 1;
            this.formData["ANNÉE403"] = this.formData["ANNÉE403"] + 1;
          }
        }
        if (this.formData["MOIS403"] == this.formData["MOIS30_3"]) {
          this.formData["MOIS30_3"] = this.formData["MOIS30_3"] + 1;
          if (this.formData["MOIS30_3"] == 13) {
            this.formData["MOIS30_3"] = 1;
            this.formData["ANNÉE30_3"] = this.formData["ANNÉE30_3"] + 1;
          }
        }
        this.formData["MONTANT70"] = 0;
        this.formData["MONTANT303"] = Number(prix * 0.3).toFixed(2);
        this.formData["MONTANT403"] = Number(prix * 0.4).toFixed(2);
        this.formData["MONTANT30_3"] = Number(prix * 0.3).toFixed(2);
        console.log(type);
      } else {
        this.formData["ANNÉE30"] = "";
        this.formData["MOIS30"] = "";
        this.formData["MOIS70"] = "";
        this.formData["ANNÉE70"] = "";
        this.formData["MONTANT30"] = "";
        this.formData["MOIS303"] = "";
        this.formData["MOIS403"] = "";
        this.formData["ANNÉE403"] = "";
        this.formData["MOIS30_3"] = "";
        this.formData["ANNÉE30_3"] = "";
        this.formData["MONTANT403"] = "";
        this.formData["MONTANT303"] = "";
        this.formData["ANNÉE303"] = "";
        this.formData["MONTANT30_3"] = "";
        this.formData["MONTANT70"] = "";
        this.formData["MOIS100"] = day > 24 ? (month + 1 > 12 ? 1 : month + 1) : month;
        this.formData["ANNÉE100"] = day > 24 ? (month + 1 > 12 ? year + 1 : year) : year;
        this.formData["MONTANT100"] = Number(prix).toFixed(2);
      }
      console.log(type);
    },
    testIfFirstTimeSaveAndSendEmail() {
      // sendEmailToUser
      this.userSaving = true;
      this.sendEmailToUserToResume();
      //save data
      this.saveCurrentData();
    },
    printWindow: function (tite) {
      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
          <html>
              ${document.getElementById("toPrint").innerHTML}
          </html>`);

      WinPrint.document.title = tite;
      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function () {
        // WinPrint.print();
        // WinPrint.close();
      }, 1000); //run this after 3 seconds
    },
    // printDiv2(printpage, name) {
    //   document.title = name;
    //   // var style = document.getElementsByTagName("style")[0].outerHTML;
    //   var headstr = `<html><head><title>${name}</title></head><body>`;
    //   var newstr = document.getElementById(printpage).innerHTML;
    //   // var newstr = document.all.item(printpage).innerHTML;
    //   console.log(newstr);
    //   var oldstr = document.body.innerHTML;
    //   document.body.innerHTML = headstr + newstr;
    //   window.print();
    //   window.close();
    //   document.body.innerHTML = oldstr;
    //   return true;
    // },
    // printDiv2(printpage, name) {
    //   // Save the original document title
    //   const originalTitle = document.title;
    //   document.title = name;

    //   // Get the contents to print
    //   const printContent = document.getElementById(printpage).innerHTML;
    //   console.log(printContent);
    //   // Save the current document content
    //   const originalContent = document.body.innerHTML;

    //   // Create a new document structure for printing
    //   const newDocumentContent = `
    //     <html>
    //       <head>
    //         <title>${name}</title>
    //         <style>
    //           ${Array.from(document.styleSheets)
    //             .map((styleSheet) => {
    //               try {
    //                 return Array.from(styleSheet.cssRules)
    //                   .map((rule) => rule.cssText)
    //                   .join("");
    //               } catch (e) {
    //                 return "";
    //               }
    //             })
    //             .join("")}
    //         </style>
    //       </head>
    //       <body>
    //         ${printContent}
    //       </body>
    //     </html>
    //   `;

    //   // Replace the current document content with the new one
    //   document.body.innerHTML = newDocumentContent;

    //   // Ensure images are loaded before printing
    //   const images = document.body.getElementsByTagName("img");
    //   const imagesLoaded = Array.from(images).map((img) => {
    //     return new Promise((resolve, reject) => {
    //       if (img.complete) {
    //         resolve();
    //       } else {
    //         img.onload = resolve;
    //         img.onerror = reject;
    //       }
    //     });
    //   });

    //   // Wait for all images to load, then print
    //   Promise.all(imagesLoaded)
    //     .then(() => {
    //       window.print();
    //     })
    //     .catch((error) => {
    //       console.error("Error loading images:", error);
    //     })
    //     .finally(() => {
    //       // Restore the original document content and title
    //       document.body.innerHTML = originalContent;
    //       document.title = originalTitle;
    //     });

    //   return true;
    // },

    // printDiv2(printpage, name) {
    //   // Save the original document title
    //   const originalTitle = document.title;
    //   document.title = name;

    //   // Get the element to print
    //   const printElement = document.getElementById(printpage);

    //   // Show the element
    //   printElement.style.display = "block";

    //   // Wait for the element to render
    //   setTimeout(() => {
    //     // Get the contents to print
    //     const printContent = printElement.innerHTML;
    //     console.log(printContent);

    //     // Save the current document content
    //     const originalContent = document.body.innerHTML;

    //     // Create a new document structure for printing
    //     const newDocumentContent = `
    //   <html>
    //     <head>
    //       <title>${name}</title>
    //       <style>
    //         ${Array.from(document.styleSheets)
    //           .map((styleSheet) => {
    //             try {
    //               return Array.from(styleSheet.cssRules)
    //                 .map((rule) => rule.cssText)
    //                 .join("");
    //             } catch (e) {
    //               return "";
    //             }
    //           })
    //           .join("")}
    //       </style>
    //     </head>
    //     <body>
    //       ${printContent}
    //     </body>
    //   </html>
    // `;

    //     // Replace the current document content with the new one
    //     document.body.innerHTML = newDocumentContent;

    //     // Ensure images are loaded before printing
    //     const images = document.body.getElementsByTagName("img");
    //     const imagesLoaded = Array.from(images).map((img) => {
    //       return new Promise((resolve, reject) => {
    //         if (img.complete) {
    //           resolve();
    //         } else {
    //           img.onload = resolve;
    //           img.onerror = reject;
    //         }
    //       });
    //     });

    //     // Wait for all images to load, then print
    //     Promise.all(imagesLoaded)
    //       .then(() => {
    //         window.print();
    //         printElement.style.display = "none";
    //       })
    //       .then(() => {
    //         // Hide the element again
    //       })
    //       .catch((error) => {
    //         console.error("Error loading images:", error);
    //       })
    //       .finally(() => {
    //         // Restore the original document content and title
    //         document.body.innerHTML = originalContent;
    //         document.title = originalTitle;
    //       });
    //   }, 0); // Adjust the timeout delay if necessary
    //   // printElement.style.display = "none";
    //   return true;
    // },
    printDiv2(printpage, name) {
      // Save the original document title
      const originalTitle = document.title;
      document.title = name;

      // Get the element to print
      const printElement = document.getElementById(printpage);
      const originalDisplay = printElement.style.display;

      // Show the element
      printElement.style.display = "block";

      // Wait for the element to render
      setTimeout(() => {
        // Get the contents to print
        const printContent = printElement.innerHTML;

        // Save the current document content
        const originalContent = document.body.innerHTML;

        // Create a new document structure for printing
        const newDocumentContent = `
      <html>
        <head>
          <title>${name}</title>
          <style>
            ${Array.from(document.styleSheets)
              .map((styleSheet) => {
                try {
                  return Array.from(styleSheet.cssRules)
                    .map((rule) => rule.cssText)
                    .join("");
                } catch (e) {
                  return "";
                }
              })
              .join("")}
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `;

        // Replace the current document content with the new one
        document.body.innerHTML = newDocumentContent;

        // Ensure images are loaded before printing
        const images = document.body.getElementsByTagName("img");
        const imagesLoaded = Array.from(images).map((img) => {
          return new Promise((resolve, reject) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = reject;
            }
          });
        });

        // Wait for all images to load, then print
        Promise.all(imagesLoaded)
          .then(() => {
            window.print();
          })
          .catch((error) => {
            console.error("Error loading images:", error);
          })
          .finally(() => {
            // Set up the afterprint event to restore the original document content and hide the element
            window.onafterprint = function () {
              console.log("Printing completed...");
              document.body.innerHTML = originalContent;
              document.title = originalTitle;
              printElement.style.display = originalDisplay;
              document.getElementById(printpage).style.display = "none";

              // Remove the onafterprint event listener
              window.onafterprint = null;
            };
          });
      }, 0); // Adjust the timeout delay if necessary

      return true;
    },
    printDiv(divId, title) {
      var vm = this;
      vm.loading = true;
      var element = document.getElementById(divId);
      var clonedElement = element.cloneNode(true);
      clonedElement.style = "";
      document.body.appendChild(clonedElement);
      html2canvas(clonedElement, { scale: 5 }).then((canvas) => {
        clonedElement.remove();
        var imgData = canvas.toDataURL("image/png");
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        var doc = new jsPDF("p", "mm");
        var position = 0;

        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 10) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        doc.save(title + ".pdf");
        vm.loading = false;
        this.dataChange = false;
      });
    },
    sendEmailToUserToResume() {
      //verifier si email no send
      if (
        this.currentUserId !== "" &&
        this.formData.mail !== "" &&
        this.formData.mail !== null &&
        this.formData.emailSent == ""
      ) {
        console.log("create user", this.formData.mail);
        this.formData.emailSent = true;
        var email = this.formData.mail;
        var object = "Pour finir de compléter votre bon de commande Gospel Event";
        var message = this.firstTimeConnectionMsg(this.currentUserId);
        this.sendEmail(email, object, message);
      }
    },
    generateAndsendNewLink() {
      console.log("sendEmail");
      this.currentUserId = this.generateNewUserId();
      var email = this.formData.mail;
      var object = "Bienvenu dans Gospel App BDC";
      var message = this.firstTimeConnectionMsg(this.currentUserId);
      this.sendEmail(email, object, message);
      this.createNewUserInBDD();
    },
    sendFinalBDC() {
      this.goNext();
      console.log("sendFinalBDC");
      var email = "virginie.gospelevent@icloud.com";
      // var email = "mouzaoui.sa@gmail.com";
      var object = `BDC Cérémonie ${this.formatDate(this.formData.date)} ${
        this.formData.nomVille
      } ${this.formData.groupe}`;
      var message = this.toAdminMsg(this.currentUserId);
      this.sendEmail(email, object, message);

      email = this.formData.mail;
      object = `Réception de votre bon de commande Gospel Event`;
      message = this.finalClientMsg(this.currentUserId);
      this.sendEmail(email, object, message);
    },
    toAdminMsg(id) {
      var msg = `Pour télécharger le bon de commande: <br>
      https://gospel-bdc.web.app/?id=${id}&admin=true  <br>`;
      for (var i in this.formData) {
        if (this.VarLab.map((e) => e.nomVariable).indexOf(i) !== -1 && this.formData[i] !== " ") {
          msg += `<br> ${
            this.VarLab.map((e) => e.label)[this.VarLab.map((e) => e.nomVariable).indexOf(i)]
          } <strong>${this.testIfitIsADate(this.formData[i])}</strong>`;
        }
      }
      return msg;
    },
    sendMailToAdmin() {},
    goBack() {
      var e6 = this.formData.e6;
      if (e6 == 1) {
        this.formData.e6 = "";
      } else {
        this.formData.e6--;
      }
    },
    goNext() {
      var e6 = this.formData.e6;
      if (e6 == "") {
        this.formData.e6 = 1;
      } else if (e6 > 1) {
        this.formData.e6++;
      } else {
        this.formData.e6++;
      }
      this.saveCurrentData();
      window.scrollTo(0, 0);
    },
    saveCurrentData() {
      if (this.currentUserId !== "") {
        this.updateUserInBDD();
      }
    },
    createNewUserInBDD() {
      this.loading = true;
      console.log("createNewUserInBDD");
      this.tmpLastSave = new Date();
      var url = this.$store.state.url;
      var data = JSON.parse(JSON.stringify(this.formData));
      data.id = this.currentUserId;
      console.log(data);
      var action = "insert";
      var table = "bdd";
      var querry =
        url +
        "?action=" +
        action +
        "&table=" +
        table +
        "&data=" +
        encodeURIComponent(JSON.stringify(data));
      fetch(querry)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          this.loading = false;
          this.dataChange = false;
        })
        .catch((err) => console.log(err.message));
    },
    updateUserInBDD() {
      this.loading = true;
      this.tmpLastSave = new Date();
      this.formData.id = this.currentUserId;
      var url = this.$store.state.url;
      var data = JSON.parse(JSON.stringify(this.formData));
      console.log(data);
      var action = "update";
      var table = "bdd";
      var id = this.formData.id;
      delete data.row;
      var querry =
        url +
        "?action=" +
        action +
        "&table=" +
        table +
        "&id=" +
        id +
        "&data=" +
        encodeURIComponent(JSON.stringify(data));
      fetch(querry)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          this.loading = false;
          this.dataChange = false;
          this.userSaving = false;
          // return(data)
          // d.id = data.data.id;
          // d.saved = true;
        })
        .catch((err) => console.log(err.message));
    },
    getDataOfExistingUser(id) {
      var vm = this;
      vm.loading = true;
      var url = this.$store.state.url;
      var data = JSON.parse(JSON.stringify(this.formData));
      console.log(data);
      var action = "read";
      var table = "bdd";
      var q = url + "?action=" + action + "&table=" + table + "&id=" + id;
      console.log(q);
      fetch(q)
        .then((res) => res.json())
        .then((data) => {
          console.log(data.data.date);
          if (data.success) {
            data.data.documentComplLe = this.formatDate2(data.data.documentComplLe);
            data.data.date = this.formatDate2(data.data.date);
            vm.formData = data.data;
            vm.loading = false;
            this.dataChange = false;
          } else {
            console.log(data);
          }
        })
        .catch((err) => console.log(err.message));
    },
    generateNewUserId() {
      return Math.random() // Generate random number, eg: 0.123456
        .toString(36) // Convert  to base-36 : "0.4fzyo82mvyr"
        .slice(-8); // Cut off last 8 characters : "yo82mvyr"
    },
    test(e) {
      console.log(e);
    },
    firstTimeConnectionMsg(id) {
      var msg = `Bonjour ${this.formData.Prénom.trim()},<br><br>
      Voici le lien qui vous permet de finaliser votre bon de commande: <br>
      https://gospel-bdc.web.app/?id=${id}<br><br>
      Si vous le souhaitez, vous pouvez joindre Virginie DORÉ sur son mobile au 07 68 88 94 36 pour toute précision.<br><br>
      Bien à vous,<br>
      L'équipe Gospel Event
      `;
      return msg;
    },
    finalClientMsg() {
      var msg = `Bonjour ${this.formData.Prénom.trim()},<br><br>
      Nous avons bien reçu votre bon de commande. <br>
      Virginie va vous revenir dans les meilleurs délais.<br><br>
      Bien à vous,<br>
      L'équipe Gospel Event
      `;
      return msg;
    },
    sendEmail(email, object, message) {
      var url = this.$store.state.urlMail;
      this.loading = true;
      // var groupe = this.state.groupe;
      console.log(url + "?message=" + message + "&object=" + object + "&email=" + email);
      fetch(
        url + "?message=" + encodeURIComponent(message) + "&object=" + object + "&email=" + email
      )
        .then((res) => res.json())
        .then((da) => {
          console.log(da);
          this.loading = false;
          this.dataChange = false;
          this.snackbar = true;
        })
        .catch((err) => console.log(err.message));
    },
    saveFilterTodb(d) {
      var url = this.$store.state.url;
      console.log(d);
      var data = JSON.parse(JSON.stringify(d));
      console.log(data);
      var action2 = "insert";
      var table2 = "bdd";
      var q =
        url +
        "?action=" +
        action2 +
        "&table=" +
        table2 +
        "&data=" +
        encodeURIComponent(JSON.stringify(data));
      fetch(q)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          // return(data)
          // d.id = data.data.id;
          // d.saved = true;
        })
        .catch((err) => console.log(err.message));
    },
    testIfitIsADate(date) {
      // console.log(date);
      if (isNaN(Date.parse(date)) || String(date).length < 6) {
        //not a date
        return date;
      } else {
        // is a date => format
        return this.formatDate(date);
      }
    },

    formatDate(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${day}/${month}/${year}`;
    },
    formatDate2(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${year}-${month}-${day}`;
    },
  },
  watch: {
    formData: {
      handler() {
        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
        var vm = this;
        vm.dataChange = true;
        console.log("formData hase changed");
      },
      deep: true,
    },
  },
};
</script>

<style>
.centered-input input {
  text-align: center;
}
/* .centered-input textarea {
  text-align: center;
} */
/* .centered-input div {
  text-align: center;
} */
.v-chip .v-chip__content {
  margin: 10px;
}
.v-chip-group .v-slide-group__content {
  justify-content: center;
}
.v-stepper__step {
  /* flex: 1 1; */
  /* flex-wrap: nowrap;
  padding: 15px !important; */
}
.v-stepper__header {
  height: none;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
}

.v-text-field .v-label {
  max-width: 90%;
  overflow: visible !important;
  text-overflow: ellipsis;
  top: 6px;
  white-space: normal !important;
  pointer-events: none;
}
.v-input__control {
  flex-direction: column-reverse !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  margin: 0px !important;
  overflow: hidden;
}
.v-stepper__step {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 15px !important;
  position: relative;
}
.v-sheet.v-stepper:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.v-stepper__header {
  height: 72px;
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-shadow: none !important;
}
.v-stepper__content {
  top: 0;
  padding: 0px 0px 0px 0px !important;
}
.theme--light.v-card > .v-card__text,
.theme--light.v-card > .v-card__subtitle {
  padding: 0px 0px 0px 0px !important;
}
.v-text-field.v-text-field--enclosed {
  max-width: 430px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
.container {
  width: 100%;
  padding: 12px;
  padding-top: 0px;
  margin-right: auto;
  margin-left: auto;
}
/* textarea {
  text-align: center;
} */

.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  width: 100%;
  padding: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0 0 !important;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.v-input--hide-details > .v-input__control > .v-input__slot {
  display: flex;
  justify-content: center;
}
.v-list-item__title,
.v-list-item__subtitle {
  flex: 1 1 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal !important;
}
</style>
